import { ReactNode } from 'react';

import EmptyState from 'app/components/UI/EmptyState';

import { RECONCILIATION_DETAILS_NOT_RECORDED } from 'app/constants/reconciliations';

interface ReconciliationRunDetailsGateProps {
  isRunning: boolean;
  detailsAvailable: boolean;
  pendingText: string;
  children: ReactNode;
}

/**
 * Shows a run tab's content only once the run has finished and recorded its details; until then, says what will
 * appear and when, or that the run recorded none.
 */
function ReconciliationRunDetailsGate({
  isRunning,
  detailsAvailable,
  pendingText,
  children,
}: ReconciliationRunDetailsGateProps) {
  if (isRunning) {
    return (
      <EmptyState
        text={`This reconciliation is still running. ${pendingText} will appear here when it finishes.`}
      />
    );
  }

  if (!detailsAvailable) {
    return <EmptyState text={RECONCILIATION_DETAILS_NOT_RECORDED} />;
  }

  return children;
}

export default ReconciliationRunDetailsGate;
